import { useLeagueContext } from "@/modules/leagues/hooks/useLeagueContext";
import { useLeagueFeed } from "@/modules/leagues/hooks/useLeagueFeed";
import { FeedItem } from "@/modules/leagues/components/FeedItem";
import { SkeletonText } from "@/components/atoms/Skeleton";
import { EmptyState } from "@/components/organisms/EmptyState";
import { WhistleConfettiIllustration } from "@/components/atoms/illustrations";
import { ErrorState } from "@/components/organisms/ErrorState";

export function LeagueFeedPage() {
  const { league } = useLeagueContext();
  const { data: events, isLoading, isError, refetch } = useLeagueFeed(league.id);

  if (isLoading) {
    return (
      <div className="space-y-3">
        {[0, 1, 2, 3].map((i) => (
          <div key={i} className="rounded-xl border border-border bg-card p-3">
            <SkeletonText lines={2} />
          </div>
        ))}
      </div>
    );
  }

  if (isError && !events) {
    return (
      <ErrorState
        title="Não foi possível carregar o feed"
        description="Verifique sua conexão e tente novamente."
        onRetry={() => refetch()}
      />
    );
  }

  if (!events || events.length === 0) {
    return (
      <EmptyState
        illustration={WhistleConfettiIllustration}
        title="Nada por aqui ainda"
        description="Assim que houver movimentação na liga — entradas, rodadas liberadas, pontuação — tudo aparece aqui em tempo real."
      />
    );
  }

  return (
    <div className="space-y-2.5">
      {isError && (
        <p className="rounded-lg border border-warning/30 bg-warning/10 px-3 py-2 text-center text-xs text-amber-800 dark:text-warning">
          Não deu pra atualizar agora — mostrando os últimos eventos carregados.
        </p>
      )}
      {events.map((event) => (
        <FeedItem key={event.id} event={event} />
      ))}
    </div>
  );
}
